import ImageEditor from "./ImageEditor";

function EditorPage() {
  return <ImageEditor />;

  // return (
  //   <Container fluid m={0} p={0}>
  //     <Grid>
  //       <>
  //         <Grid.Col span={{ base: 12, sm: 4 }}>
  //           <ImageInfo imageData={imageData} pixelImage={pixelImage} />
  //         </Grid.Col>
  //         <Grid.Col span={{ base: 12, sm: 8 }}>
  //           <ImageEditor pixelImage={pixelImage} />
  //         </Grid.Col>
  //       </>
  //     </Grid>
  //   </Container>
  // );
}

export default EditorPage;
